import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { i18n } from '../../translate/i18n';
import { fetchEquipmentsByIdService } from '../../services/equipments'
import api from '../../axios/api';

let CancelToken = axios.CancelToken;
let fetchTenants_cancel;
let fetchTenantsById_cancel
let checkDeleteTenants_cancel;
let fetchTenantsByIdSuperadmin_cancel;
let fetchSitesByTenant_cancel;
let fetchGapUsersForOptions_cancel;
let notifyAccountables_cancel;

export const fetchTenantsSuccess = (tenants) => {
  return {
    type: actionTypes.FETCH_TENANTS_SUCCESS,
    tenants: tenants
  };
};

export const fetchTenantByIdSuccess = (tenant) => {
  return {
    type: actionTypes.FETCH_TENANTS_BY_ID_SUCCESS,
    tenant: tenant
  };
}

export const requestTenantsFail = (error) => {
  return {
    type: actionTypes.REQUEST_TENANTS_FAIL,
    error: error
  };
};

export const requestTenantsStart = () => {
  return {
    type: actionTypes.REQUEST_TENANTS_START
  };
};

export const deleteTenantsSuccess = (area) => {
  return {
    type: actionTypes.DELETE_TENANTS_SUCCESS,
    area: area
  }
}

export const checkDeleteTenantsSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_TENANTS_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updateTenantsSuccess = (area) => {
  return {
    type: actionTypes.UPDATE_TENANTS_SUCCESS,
    area: area
  }
}

export const postTenantsSuccess = (area) => {
  return {
    type: actionTypes.POST_TENANTS_SUCCESS,
    area: area
  }
}

export const fetchTenants = (page, limit, search, order, orderBy) => {
  fetchTenants_cancel && fetchTenants_cancel()
  return dispatch => {
    dispatch(requestTenantsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('/tenants' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchTenants_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchTenantsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestTenantsFail(err));
      });
  };
};

export const fetchTenantsById = (id) => {
  fetchTenantsById_cancel && fetchTenantsById_cancel()

  return dispatch => {
    dispatch(requestTenantsStart());
    API.get('/tenants/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchTenantsById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchTenantByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestTenantsFail(err));
      });
  };
};

export const fetchTenantsByIdSuperadmin = (id) => {
  fetchTenantsByIdSuperadmin_cancel && fetchTenantsByIdSuperadmin_cancel()

  return dispatch => {
    dispatch(requestTenantsStart());
    API.get('/tenants/' + id + '/superadmin', {
      cancelToken: new CancelToken(function executor(c) {
        fetchTenantsByIdSuperadmin_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchTenantByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestTenantsFail(err));
      });
  };
};

export const deleteTenants = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.put('/tenants/delete/' + index)
        .then(res => {
          dispatch(deleteTenantsSuccess(res.data));
          toastr.success(i18n.t('deleteTenants.toastr'), `${res.data.name}${i18n.t('deleteTenants.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeleteTenants = (index) => {
  checkDeleteTenants_cancel && checkDeleteTenants_cancel()
  return dispatch => {
    dispatch(requestTenantsStart());
    API.get('/tenants/' + index + '/checkdelete', {
      cancelToken: new CancelToken(function executor(c) {
        checkDeleteTenants_cancel = c;
      })
    })
      .then(res => {
        dispatch(checkDeleteTenantsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestTenantsFail(err));
      });
  }
}

export const postTenants = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestTenantsStart());
      API.post('/tenants', body)
        .then(res => {
          dispatch(postTenantsSuccess(res.data));
          toastr.success(i18n.t('postTenants.toastr'), `${res.data.name}${i18n.t('postTenants.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postTenants.toastrError'), i18n.t('postTenants.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateTenants = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.put('/tenants/' + index, body)
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          toastr.success(i18n.t('updateTenants.toastr'), `${body.name}${i18n.t('updateTenants.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateTenants.toastrError'), i18n.t('updateTenants.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateTenantsSuperadmin = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.put('/tenants/' + index + '/superadmin', body)
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          toastr.success(i18n.t('updateTenantsSuperadmin.toastr'), `${body.name}${i18n.t('updateTenantsSuperadmin.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateTenantsSuperadmin.toastrError'),i18n.t('updateTenantsSuperadmin.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateFeatureFlags = (tenantid, index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.put('/tenants/' + tenantid + '/addfeatureflag/' + index, body)
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          dispatch(fetchTenantsById(tenantid));
          toastr.success(i18n.t('updateFeatureFlags.toastr'), `${res.data.name}${i18n.t('updateFeatureFlags.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "feature flag not found") {
            toastr.error(i18n.t('updateFeatureFlags.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const postFeatureFlags = (tenantid, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.post('/tenants/' + tenantid + '/addfeatureflag', body)
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          toastr.success(i18n.t('postFeatureFlags.toastr'), `${res.data.name}${i18n.t('postFeatureFlags.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })
  }
}

export const deleteFeatureFlags = (tenantid, index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestTenantsStart());
      API.put('/tenants/' + tenantid + '/addfeatureflag/' + index + '/delete')
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          toastr.success(i18n.t('deleteFeatureFlags.toastr'), `${res.data.name}${i18n.t('deleteFeatureFlags.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "feature flag not found") {
            toastr.error(i18n.t('deleteFeatureFlags.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

export const updateFeatureFlagsAdmin = (tenantid, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestTenantsStart());
      API.put('/tenants/' + tenantid + '/featureflags', body)
        .then(res => {
          dispatch(updateTenantsSuccess(res.data));
          toastr.success(i18n.t('updateFeatureFlags.toastr'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestTenantsFail(err));
          if (err.response.data.message === "feature flag not found") {
            toastr.error(i18n.t('updateFeatureFlags.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

const fetchEquipmentModelsStart = () => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_START,
  }
}

const fetchEquipmentModelsSuccess = (equipmentModels) => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_SUCCESS,
    equipmentModels,
  }
}

const fetchEquipmentModelsError = (error) => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_MODELS_ERROR,
    error,
  }
}

export const tenantFetchEquipmentModels = (tenantId) => {
  return dispatch => {
    dispatch(fetchEquipmentModelsStart());
    api.get(`/equipmentmodels/superadmin/${tenantId}`)
      .then(res => {
        dispatch(fetchEquipmentModelsSuccess(res.data.equipmentModels));
      })
      .catch(err => {
        dispatch(fetchEquipmentModelsError(err));
      });
  };
};

const fetchEquipmentStart = () => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_START,
  }
}

const fetchEquipmentSuccess = (equipment) => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_SUCCESS,
    equipment,
  }
}

const fetchEquipmentError = (error) => {
  return {
    type: actionTypes.TENANTS_FETCH_EQUIPMENT_BY_ID_ERROR,
    error,
  }
}

export const tenantFetchEquipmentById = (equipmentId) => {
  return dispatch => {
    dispatch(fetchEquipmentStart());
    fetchEquipmentsByIdService(equipmentId)
      .then(res => {
        dispatch(fetchEquipmentSuccess(res.data.equipment));
      })
      .catch(err => {
        dispatch(fetchEquipmentError(err));
      });
  };
};

const fetchSitesForModalSuccess = (sites) => {
  return {
    type: actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_SUCCESS,
    sites,
  };
};

const fetchSitesForModalFail = () => {
  return {
    type: actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_FAIL,
  };
};

const fetchSitesForModalStart = () => {
  return {
    type: actionTypes.TENANTS_FETCH_SITES_FOR_MODALS_START,
  };
};

export const fetchSitesForModalByTenant = (tenantId, page, limit, search, order, orderBy) => {
  fetchSitesByTenant_cancel && fetchSitesByTenant_cancel();
  return dispatch => {
    dispatch(fetchSitesForModalStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('tenants/' + tenantId + '/sites' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchSitesByTenant_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchSitesForModalSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchSitesForModalFail());
        console.log(err);
      });
  };
};

const requestApiKeyStart = (type) => {
  return {
    type,
  }
}

const requestApiKeyFinish = (type) => {
  return {
    type,
  }
}

export const createApiKey = (tenantId) => {
  return (dispatch) => {
    dispatch(requestApiKeyStart(actionTypes.TENANT_CREATE_API_KEY_START));
    API.post(`tenants/${tenantId}/createapikey`)
      .then(() => {
        dispatch(requestApiKeyFinish(actionTypes.TENANT_CREATE_API_KEY_SUCCESS));
        toastr.success('Chave da Api criada com sucesso');
        dispatch(fetchTenantsById(tenantId));
      })
      .catch((e) => {
        console.error(e);
        dispatch(requestApiKeyFinish(actionTypes.TENANT_CREATE_API_KEY_FAIL));
        toastr.error('Falha ao criar chave da api');
      })
  }
}

export const deleteApiKey = (tenantId, apiKeyId) => {
  return (dispatch) => {
    dispatch(requestApiKeyStart(actionTypes.TENANT_DELETE_API_KEY_START));
    API.put(`tenants/${tenantId}/deleteapikey/${apiKeyId}`)
      .then(() => {
        dispatch(requestApiKeyFinish(actionTypes.TENANT_DELETE_API_KEY_SUCCESS));
        toastr.success('Chave da Api deletada com sucesso');
        dispatch(fetchTenantsById(tenantId));
      })
      .catch((e) => {
        console.error(e);
        dispatch(requestApiKeyFinish(actionTypes.TENANT_DELETE_API_KEY_FAIL));
        toastr.error('Falha ao deletar chave da api');
      })
  }
}

const tenantGetNotificationWebhookStart = () => {
  return {
    type: actionTypes.TENANT_GET_WEBHOOK_START,
  }
}

const tenantGetNotificationWebhookSuccess = (notificationWebhook) => {
  return {
    type: actionTypes.TENANT_GET_WEBHOOK_SUCCESS,
    notificationWebhook,
  }
}

const tenantGetNotificationWebhookFail = () => {
  return {
    type: actionTypes.TENANT_GET_WEBHOOK_FAIL,
  }
}

export const tenantGetNotificationWebhook = (tenantId) => {
  return (dispatch) => {
    dispatch(tenantGetNotificationWebhookStart());
    API.get(`tenants/${tenantId}/getnotificationwebhook`)
      .then((res) => {
        dispatch(tenantGetNotificationWebhookSuccess(res.data));
      })
      .catch((e) => {
        console.error(e);
        dispatch(tenantGetNotificationWebhookFail());
      })
  }
}

const tenantUpdateNotificationWebhookStart = () => {
  return {
    type: actionTypes.TENANT_UPDATE_WEBHOOK_START,
  }
}

const tenantUpdateNotificationWebhookSuccess = () => {
  return {
    type: actionTypes.TENANT_UPDATE_WEBHOOK_SUCCESS,
  }
}

const tenantUpdateNotificationWebhookFail = () => {
  return {
    type: actionTypes.TENANT_UPDATE_WEBHOOK_FAIL,
  }
}

export const tenantUpdateNotificationWebhook = (tenantId, body) => {
  return (dispatch) => {
    dispatch(tenantUpdateNotificationWebhookStart());
    API.put(`tenants/${tenantId}/updatenotificationwebhook`, body)
      .then(() => {
        dispatch(tenantGetNotificationWebhook(tenantId));
        dispatch(tenantUpdateNotificationWebhookSuccess());
        toastr.success('Webhook atualizado com sucesso');
      })
      .catch((e) => {
        console.error(e);
        dispatch(tenantUpdateNotificationWebhookFail());
        toastr.error('Falha ao atualizar o webhook');
      })
  }
}

const tenantUpdateEquipmentsRegistrationLimitStart = () => {
  return {
    type: actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_START,
  }
}

const tenantUpdateEquipmentsRegistrationLimitSuccess = () => {
  return {
    type: actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_SUCCESS,
  }
}

const tenantUpdateEquipmentsRegistrationLimitFail = () => {
  return {
    type: actionTypes.TENANT_UPDATE_EQUIPMENTS_REGISTRATION_LIMIT_FAIL,
  }
}


export const tenantUpdateEquipmentsRegistrationLimit = (tenantId, body) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(tenantUpdateEquipmentsRegistrationLimitStart());
      API.patch(`tenants/${tenantId}/updateEquipmentsRegistrationLimit`, body)
        .then(() => {
          dispatch(tenantUpdateEquipmentsRegistrationLimitSuccess());
          toastr.success('Plano atualizado com sucesso');
          resolve('success');
        })
        .catch((e) => {
          console.error(e);
          dispatch(tenantUpdateEquipmentsRegistrationLimitFail());
          toastr.error('Falha ao atualizar o plano');
          reject('failed');
        })
    });
  }
}




export const fetchTenantEquipmentsCountSuccess = (count) => {
    return {
        type: actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_SUCCESS,
        count
    };
};

export const requestTenantEquipmentsCountFail = (error) => {
    return {
        type: actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_FAIL,
        error: error
    };
};

export const requestTenantEquipmentsCountStart = () => {
    return {
        type: actionTypes.TENANT_FETCH_EQUIPMENTS_COUNT_START
    };
};

export const fetchTenantEquipmentsCount = (input) => {
    const  { isSuperadmin = false, tenantId = null } = input || {};

    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(requestTenantEquipmentsCountStart());

            API.get(`equipments/count/${isSuperadmin ? tenantId : ''}`)
            .then(res => {
              dispatch(fetchTenantEquipmentsCountSuccess(res.data.count))
              resolve(res.data);
            })
            .catch(err => {
              dispatch(requestTenantEquipmentsCountFail(err));
              reject(err);
            });
        });
    }
};

export const toggleEquipmentsLimitModal = () => {
    return {
        type: actionTypes.TOGGLE_EQUIPMENTS_LIMIT_MODAL
    };
};

const fetchGapUsersForOptionsSuccess = (users) => {
  return {
    type: actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_SUCCESS,
    users,
  };
};

const fetchGapUsersForOptionsFail = () => {
  return {
    type: actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_FAIL,
  };
};

const fetchGapUsersForOptionsStart = () => {
  return {
    type: actionTypes.TENANTS_FETCH_GAP_USERS_FOR_OPTIONS_START,
  };
};

export const fetchGapUsersForOptions = (page, limit, search, order, orderBy) => {
  fetchGapUsersForOptions_cancel && fetchGapUsersForOptions_cancel();
  return dispatch => {
    dispatch(fetchGapUsersForOptionsStart());
    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
    API.get('users/gap' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchGapUsersForOptions_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchGapUsersForOptionsSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchGapUsersForOptionsFail());
        console.log(err);
      });
  };
};


const notifyAccountablesSuccess = () => {
  return {
    type: actionTypes.TENANT_NOTIFY_ACCOUNTABLES_SUCCESS,
  };
};

const notifyAccountablesFail = () => {
  return {
    type: actionTypes.TENANT_NOTIFY_ACCOUNTABLES_FAIL,
  };
};

const notifyAccountablesStart = () => {
  return {
    type: actionTypes.TENANT_NOTIFY_ACCOUNTABLES_START,
  };
};

export const notifyAccountables = () => {
  notifyAccountables_cancel && notifyAccountables_cancel();

  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(notifyAccountablesStart());

      API.get('/tenants/notifyAccountables', {
        cancelToken: new CancelToken(function executor(c) {
          notifyAccountables_cancel = c;
        })
      })
        .then(res => {
          dispatch(notifyAccountablesSuccess(res.data));
          resolve('success')
        })
        .catch(err => {
          dispatch(notifyAccountablesFail());
          console.log(err);
          reject('error')
        });
    })
  };
};
